<template>
	<div class="electroUsageRecord">
		<el-dialog :title="title" :visible.sync="dialog.show" :width="width" @close="handclose" center :close-on-click-modal="false">
			<div class="center">
				<el-form ref="form" class="lz-seach-animation" inline @submit.native.prevent>
					<el-form-item label="关键词">
						<el-input v-model="seachData.keyword" placeholder="印章名称、用印人" @keyup.enter.native="seachInput" clearable></el-input>
					</el-form-item>
					<el-form-item label="用印日期">
						<el-date-picker
						      v-model="seachData.dateList"
						      type="datetimerange"
						      :picker-options="pickerOptions"
						      range-separator="至"
						      start-placeholder="开始日期"
						      end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"
						      align="right" @change="changeDatePicker">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-search" plain size="small" type="primary" @click="seachInput">搜索</el-button>
					</el-form-item>
				</el-form >
				<el-table :data="tableData" style="width: 100%" border>
					<el-table-column align="center" label="用印时间" prop="createDate" width="140"></el-table-column>
					<el-table-column :show-overflow-tooltip="true" align="center" label="申请单名称" prop="contractTitle"></el-table-column>
					<el-table-column :show-overflow-tooltip="true" align="center" label="用印人" prop="userName"></el-table-column>
					<el-table-column :show-overflow-tooltip="true" align="center" label="电子印章名" prop="sealName"></el-table-column>
					<el-table-column :show-overflow-tooltip="true" align="center" label="使用方式" prop="authorize.remark"></el-table-column>
					<el-table-column :show-overflow-tooltip="true" align="center" label="用印次数" prop="signTotal"></el-table-column>
					<el-table-column align="center" label="备注" prop="remark" width="120"></el-table-column>
					<el-table-column :show-overflow-tooltip="true" align="center" fixed="right" label="操作" width="120">
						<template slot-scope="scope">
							<el-button size="mini" type="text" @click="seeUsageRecord(scope.row)">查看</el-button>
							<el-button size="mini" type="text" @click="remark(scope.row)">备注</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination :current-page="page.pageNum" :page-size="page.pageSize" :page-sizes="[10,20,30,40,50]"
				:total="page.total" class="lz-el-pagination" layout="total, sizes, prev, pager, next, jumper"
				@current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>
			</div>
		</el-dialog>
		
		
	</div>
</template>

<script>
	let that 
	import { PDFDocument } from 'pdf-lib';
	import {
		mapGetters
	} from 'vuex'

	export default {
		computed: {
			...mapGetters(['api','userInfo']),
		},
		name: 'electroUsageRecord',
		props: {
			close:{type:Function},
			confirm: {type:Function},
			cancel: {type:Function},
			width: {
				type: String,
				default: '80%'
			},
			title: {
				type: String,
				default: '选择'
			},
			sealId:{
				type: String,
				default: ''
			}
		},
		data() {
			return {
				dialog:{
					show:false,
				},
				tableData:[],
				//搜索
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				//搜索
				seachData: {
					keyword: '' ,//合同标题
					dateList:'',//创建日期
					start:'',
					end:''
				},
				page:{
					page: true,
					pageNum: 1,
					pageSize: 10,
					total:0
				},
			}
		},
		mounted() {
			that =this
		},
		methods: {
			//获取合同详情
			seeUsageRecord(row){
				that.GLOBAL.doGet(this.api.GLOBAL_electronic_seal_findContractDetail+'/'+row.sealInfoId,{sealId:row.sealId},(res)=>{
					if(res.code==200){
						let url=res.data.contractFile.host+res.data.contractFile.relativePath +'?Authorization='+that.userInfo.token
						let fileName=res.data.originalName
						if(res.data.signedList&&res.data.signedList.length>0){
							let sealList= res.data.signedList.map(item=>{
								if(item.signContent){
									try{
										item.signContent=JSON.parse(item.signContent)
									}catch(e){
										item.signContent=item.signContent
									}
								}
								return item
							})
							//生成电子章，并下载
							this.modifyPdf(url,fileName,sealList,'预览')
						}else{
							this.modifyPdf(url,fileName,[],type)
						}
					}
				})
			},
			async modifyPdf(url,fileName,sealList,type) {
				const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())
				const pdfDoc = await PDFDocument.load(existingPdfBytes)
				const pages = pdfDoc.getPages()
				if(sealList.length>0){
					sealList.forEach(async (item,index)=>{
						let pngImageBytes= this.$lizhao.base64.base64ToArrayBuffer(item.sealImageData)
						let pngImage=''
						try{
							pngImage = await pdfDoc.embedPng(pngImageBytes)
						}catch(e){
							pngImage = await pdfDoc.embedJpg(pngImageBytes)
						}
						//循环获取每一页，添加印章水印
						pages.forEach((page,pageNum)=>{
							if(!item.signContent){
								return
							}
							let obj =item.signContent[pageNum+1]
							const { width, height } = page.getSize()
							if(obj.isUse==true){
								obj.sealArr.forEach(sl=>{
									page.drawImage(pngImage,{
										x:(sl.left/obj.scale),
										y: height - (sl.top/obj.scale) -150,
										width: 150,
										height:150,
									})
								})
							}
						})
					})
				}
				setTimeout(async()=>{
					const pdfBytes = await pdfDoc.save()
					const blob = new Blob([pdfBytes], {type: 'application/pdf'});
					let pdfDataUri = URL.createObjectURL(blob);
					if(type=='预览'){
						this.$lizhao.ui.pdfPreviewShow({
							width:'90%',
							src:pdfDataUri,
							success(data){
								console.log(data);
							}
						})
					}else if(type=='下载'){
						const a = document.createElement("a");
						a.href = pdfDataUri;
						a.download = fileName; // 这里填保存成的文件名
						a.click();
						URL.revokeObjectURL(a.href);
						a.remove();
					}
				},500)
			},
			//选择日期
			changeDatePicker(data){
				if(data){
					this.seachData.start=data[0]
					this.seachData.end=data[1]
				}else{
					this.seachData.start=''
					this.seachData.end=''
				}
			},
			//备注
			remark(row) {
				this.$prompt('请输入备注', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  inputPattern: /\S/,
				  inputErrorMessage: '必填'
				}).then(({ value }) => {
					let req={
						emulateJSON:false,// emulateJSON为前端需要参数
						remark:value,
						sealInfoId:row.sealInfoId,
					}
					that.GLOBAL.doPost(this.api.GLOBAL_electronic_seal_infoRemark,req,(res)=>{
						if(res.code==200){
							this.$message.success(res.msg)
							that.findList()
						}
					})
				})	
			},
			cancelFn(){
				this.dialog.show=false
				this.cancel()
			},
			//确定
			submitFn(row){
				this.dialog.show=false
				this.confirm(row)
			},
			seachInput(){
				this.findList()
			},
			show(data){
				this.dialog.show=true
				this.findList()
			},
			findList(){
				let req={
					sealId:this.sealId,
					...this.page,
					...this.seachData
				}
				that.GLOBAL.doGet(this.api.GLOBAL_electronic_seal_findSealInfoList,req,(res)=>{
					if(res.code==200&&res.data){
						this.tableData=res.data.list
						this.page.total=res.data.total
					}else{
						this.tableData=[]
						this.page.total=0
					}
				})
			},
			handclose(){
				this.close()
			},
			handleCurrentChange(val){
				that.page.pageNum = val;
				that.findList()
			},
			handleSizeChange(val){
				that.page.pageSize = val;
				that.findList()
			}
			
		}
	}
</script>

<style lang="scss" scoped>
	/deep/ .el-dialog--center .el-dialog__body{
		padding:20px 20px 0px
	}
	.electroUsageRecord {
		.center{
			overflow: hidden;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/electroUsageRecord/electroUsageRecord.vue